import gql from "../gql";
import Learning from "./Learning";
const SearchResult = gql `
  fragment SearchResult on SearchResult {
    __typename
    clickAnalyticsPayload
    learning {
      ...Learning
    }
  }
  ${Learning}
`;
export default gql `
  fragment SearchResultConnection on SearchResultConnection {
    __typename
    edges {
      __typename
      node {
        ...SearchResult
      }
    }
    pageInfo {
      __typename
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    searchAnalyticsPayload
  }
  ${SearchResult}
`;
